import { keywordCards } from "@/mocks/films";

export default function KeywordSection() {
  return (
    <section id="keywords" className="w-full bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <header className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
              <i className="ri-price-tag-3-line" aria-hidden="true"></i>
              关键词解读
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              六个常出现的词，先弄清它们分别指什么
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              港片、经典电影、动作片、武侠片、老电影与怀旧剧场并不完全并列，它们的边界常常互相交叠。
              理解各自的侧重，浏览片单时会更有方向。
            </p>
          </header>

          <ul className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {keywordCards.map((card) => (
              <li
                key={card.id}
                className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-200 transition-colors"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${card.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">{card.key}</h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}